import { useCreate } from '@refinedev/core';
import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';

export type MarkdownImage = {
  id: string;
  encodedImage: string;
};

export type MarkdownImageCollection = {
  id: string;
  images: MarkdownImage[];
};

type ConvertToMarkdownResponse = {
  dataUploadFile: UploadedFile;
  markdown: string;
  extractedImagesCollection: MarkdownImageCollection | null;
};

type ConvertToMarkdownPayload = {
  location: string;
  collectionToAttachImagesTo?: string;
};

export const useConvertToMarkdownMutation = () => {
  const { mutateAsync, error, isLoading, reset } = useCreate<ConvertToMarkdownResponse>();

  const convertToMarkdown = async (companyId: string, payload: ConvertToMarkdownPayload) => {
    const result = await mutateAsync({
      resource: `admin/companies/${companyId}/templates/convert-to-markdown`,
      values: payload,
    });
    return result.data;
  };

  return {
    convertToMarkdown,
    error,
    isLoading,
    reset,
  };
};
